<template>
  <div class="space-y-24">
    <RevInputText
      id="report-illicit-content-reporter-name"
      v-model="values.reporterName"
      :error="errors.reporterName"
      :label="i18n(translations.reporterNameLabel)"
    />

    <RevInputText
      id="report-illicit-content-reporter-email"
      v-model="values.reporterEmail"
      autocomplete="email"
      data-cs-mask
      :error="errors.reporterEmail"
      :label="i18n(translations.reporterEmailLabel)"
      type="email"
    />

    <RevInputSelect
      id="report-illicit-content-capacity"
      v-model="values.capacity"
      :description="i18n(translations.capacityHelper)"
      :error="errors.capacity"
      :label="i18n(translations.capacityLabel)"
      :options="capacityOptions"
    />

    <RevInputText
      id="report-illicit-content-country"
      v-model="values.country"
      :error="errors.country"
      :label="i18n(translations.countryLabel)"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'

import type { ReportIllicitContentFormValues } from '../../../ReportIllicitContent.types'

import translations from './ReportIllicitContentStepAbout.translations'

const i18n = useI18n()

type StepValues = Pick<
  ReportIllicitContentFormValues,
  'reporterName' | 'reporterEmail' | 'capacity' | 'country'
>

type StepErrors = {
  [K in keyof StepValues]?: string
}

defineProps<{
  errors: StepErrors
  capacityOptions: Array<{ value: string; label: string }>
}>()

const values = defineModel<StepValues>({ required: true })
</script>
